// React
import React from "react";

// Internal
import { getDataTestId } from "../functions/data-test-ids.jsx";
import { ModalButtonType } from "../modal/modal-constants.jsx";
import { SimpleModal, SimpleModalMessage } from "../simple-modal/simple-modal.jsx";

export function ErrorModal(props) {
    const getButtons = () => {
        return [
            {
                Label: props.ButtonLabel || "OK",
                Type: props.ButtonType || ModalButtonType.Primary,
                OnClick: props.OnCancel
            }
        ];
    };

    const getMessage = () => {
        if (!props.Error) return props.Message || "";
        if (props.Error.errorNumber) {
            return props.Error.description + " (" + props.Error.errorNumber + ")";
        }
        return props.Error.description;
    };

    return (
        <SimpleModal
            Show={props.Show}
            Title={props.Title || "Error"}
            Close={props.OnCancel}
            Buttons={getButtons()}
            DataTestId={props.DataTestId}>
            <SimpleModalMessage
                Message={getMessage()}
                DataTestId={getDataTestId(props.DataTestId, "error-message")} />
        </SimpleModal>
    );
}
